import React, {Component} from "react";
import {connect} from "react-redux";
import {Avatar, Popover, Icon} from "antd";
import {userSignOut} from "appRedux/actions/Auth";

class UserInfo extends Component {

  render() {
    const userMenuOptions = (
      <ul className="gx-user-popover">
        <li onClick={() => this.props.userSignOut()}>Cerrar sesión
        </li>
      </ul>
    );

    return (
      <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
        <Icon className="icon-logout" type="logout" />
      </Popover>
    )

  }
}

export default connect(null, {userSignOut})(UserInfo);



// WEBPACK FOOTER //
// ./src/components/UserInfo/index.js